<div>
  <p>
    Upload previously filed and supporting material from your device. Please
    review the
    <a
      href="https://albertacourts.ca/kb/court-operations-schedules/guidelines-for-documents-filed-by-email-or-digital-upload"
      target="_blank"
    >
      court's guidelines for document upload.
      <span
        ><mat-icon style="vertical-align: text-bottom" aria-hidden="true"
          >open_in_new</mat-icon
        ></span
      ></a
    >
    <br />A maximum of 10 files can be uploaded at a time.
  </p>
  <div
    style="width: 120px"
    fxLayout="column"
    fxLayoutAlign="start"
    fxLayoutGap="{{ FlexLayoutType.Gap.XXSmall }}"
  >
    <button mat-stroked-button color="primary" (click)="onChooseFileClick()">
      Choose file
    </button>
    <span style="font-size: small">Accepts .pdf files only</span>
  </div>
</div>
<form [formGroup]="form" [ngxsForm]="formPath" autocomplete="off">
  <ng-container formArrayName="associateDocumentUploads">
    <table mat-table matSort [dataSource]="dataSource">
      <ng-container matColumnDef="fileName">
        <th
          class="w-15 mw-15"
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
        >
          File name
        </th>
        <td class="w-15 mw-15" mat-cell *matCellDef="let e; let i = index">
          <div class="file-name">
            <div
              class="file-name"
              *ngIf="
                e?.uploadStatus == DocumentUploadStatus.Uploaded;
                else nonLinkFilename
              "
            >
              <a [routerLink]="" (click)="onOpenFile(e)">{{
                e?.document?.name
              }}</a>
            </div>
            <ng-template #nonLinkFilename>
              <ng-container>
                <div class="file-name">
                  {{ e?.document?.name }}
                </div>
              </ng-container>
            </ng-template>
          </div>
          <goa-file-upload-progress-bar
            *ngIf="
              e?.uploadStatus == DocumentUploadStatus.Uploading &&
              e?.uploadProgress < 100
            "
            [progress]="e.uploadProgress"
            style="max-width: 150px"
          >
          </goa-file-upload-progress-bar>
          <ng-container *ngFor="let error of e?.document.errors">
            <jsg-hearing-associate-materials-upload-error-view [error]="error">
            </jsg-hearing-associate-materials-upload-error-view>
          </ng-container>

          <div style="display: none" [formGroupName]="i">
            <input
              matInput
              placeholder=""
              [ngModel]="e.documentId"
              formControlName="documentId"
            />
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="size">
        <th
          class="w-10 pl-20"
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
        >
          Size
        </th>
        <td class="w-10 pl-20" mat-cell *matCellDef="let e">
          {{ formatBytes(e?.document?.size) }}
          <span *ngIf="e?.document?.pages"
            >({{ e?.document?.pages }} pages)</span
          >
        </td>
      </ng-container>

      <ng-container matColumnDef="materialType">
        <th class="w-8" mat-header-cell *matHeaderCellDef mat-sort-header>
          Material type
        </th>
        <td class="w-8" mat-cell *matCellDef="let e; let i = index">
          <div [formGroupName]="i">
            <mat-form-field style="margin: 0px">
              <mat-select
                formControlName="materialTypeId"
                [placeholder]="getMaterialTypePlaceholder(e)"
                [disabled]="e?.uploadStatus != DocumentUploadStatus.Uploaded"
                (selectionChange)="onMaterialTypeChange($event, i)"
              >
                <mat-optgroup
                  *ngFor="let group of associateMaterialTypeGroup"
                  [label]="group.materialTypeGroupName"
                  [disabled]="false"
                >
                  <mat-option
                    *ngFor="let type of group.types"
                    [value]="type.id"
                  >
                    {{ type.description }}
                  </mat-option>
                </mat-optgroup>
              </mat-select>
            </mat-form-field>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="filedDate">
        <th class="w-8 pl-20" mat-header-cell *matHeaderCellDef mat-sort-header>
          Filed date
        </th>
        <td class="w-8 pl-20" mat-cell *matCellDef="let e; let i = index">
          <div [formGroupName]="i">
            <mat-form-field style="margin: 0px">
              <input
                matInput
                readonly
                formControlName="filedDate"
                [matDatepicker]="picker"
                [max]="maxDate"
                [disabled]="getFiledDateInputDisabled(e, i)"
              />

              <mat-datepicker-toggle
                matSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th class="w-5" mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td class="w-5" mat-cell *matCellDef="let e; let i = index">
          <div fxLayout="column" fxLayoutAlign="end end">
            <ng-container
              *ngIf="
                e?.uploadStatus == DocumentUploadStatus.Uploading;
                else deletingSpinnerBlock
              "
            >
              <button
                mat-icon-button
                color="primary"
                (click)="onCancelUploadClick(i)"
              >
                <mat-icon aria-hidden="true">close</mat-icon>
              </button>
            </ng-container>
            <ng-template #deletingSpinnerBlock>
              <ng-container
                *ngIf="
                  e?.uploadStatus == DocumentUploadStatus.Deleting;
                  else deleteButtonBlock
                "
              >
                <mat-spinner
                  style="margin-right: 10px"
                  [diameter]="20"
                ></mat-spinner>
              </ng-container>
            </ng-template>
            <ng-template #deleteButtonBlock>
              <button mat-icon-button color="primary">
                <mat-icon aria-hidden="true" (click)="onDeleteUploadClick(i)"
                  >delete</mat-icon
                >
              </button>
            </ng-template>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="upload-info-row">
        <th mat-header-cell *matHeaderCellDef colspan="5">
          <jsg-hearing-associate-materials-upload-message-panel-view
            [messageText]="associateMaterialsUploadInfoText"
            panelType="info"
          ></jsg-hearing-associate-materials-upload-message-panel-view>
        </th>
      </ng-container>

      <ng-container matColumnDef="error-message-row">
        <th mat-header-cell *matHeaderCellDef colspan="5">
          <jsg-hearing-associate-materials-upload-message-panel-view
            messageText="A maximum of 10 files can be uploaded at a time."
            panelType="error"
            [canClose]="true"
            (panelClose)="onErrorPanelClose()"
          ></jsg-hearing-associate-materials-upload-message-panel-view>
        </th>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

      <tr
        [ngClass]="{ hidden: associateMaterialsUploadInfoText == '' }"
        class="message-panel-header-row"
        mat-header-row
        *matHeaderRowDef="['upload-info-row']"
      ></tr>

      <tr
        [ngClass]="{ hidden: showMaxFileCountError == false }"
        class="message-panel-header-row"
        mat-header-row
        *matHeaderRowDef="['error-message-row']"
      ></tr>

      <tr mat-row *matRowDef="let e; columns: displayedColumns"></tr>
    </table>
  </ng-container>
</form>
<div
  [hidden]="!(!tableData || tableData.length <= 0)"
  fxLayoutAlign="center center"
  fxLayout="column"
  class="mt-40"
>
  <div style="width: 100%">
    <ngx-file-drop
      accept=".pdf"
      multiple="true"
      dropZoneClassName="uploaderDropZone"
      (onFileDrop)="fileDropped($event)"
    >
      <ng-template
        ngx-file-drop-content-tmp
        let-openFileSelector="openFileSelector"
      >
        <div
          class="uploaderClick"
          fxLayoutAlign="center center"
          fxLayout="row"
          (click)="openFileSelector()"
        >
          <div
            fxLayoutAlign="center center"
            fxLayout="row"
            fxLayoutGap="{{ FlexLayoutType.Gap.XSmall }}"
          >
            <div>
              Drag and drop or<br />
              click to upload
            </div>
            <mat-icon>cloud_upload</mat-icon>
          </div>
        </div>
      </ng-template>
    </ngx-file-drop>
  </div>
</div>
